var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueuedProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 4.5H15.1875",
    stroke: "#363432",
    strokeOpacity: 0.8,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2537 9.04484C13.795 9.1225 13.4843 9.3203 13.3073 9.65522C12.99 10.2553 13.1249 10.6945 13.014 11.1379C12.903 11.5813 12.5628 11.7299 12.3182 12.0769C12.1272 12.3478 12.097 13.0067 12.4393 13.3357C12.7779 13.6586 13.0901 13.958 13.698 13.8668C14.2998 13.7792 14.6032 13.3736 15.2355 13.2471C15.8678 13.1205 16.3915 13.2364 16.7279 12.9361C17.0808 12.6212 17.4478 11.7502 17.1325 11.1216C16.879 10.616 16.2624 10.5027 15.9616 10.0288C15.6608 9.55484 15.5165 9.3438 15.2571 9.23047C14.8984 9.0738 14.6285 8.98138 14.2537 9.04484Z",
    stroke: "#363432",
    strokeOpacity: 0.8,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9H9.5625",
    stroke: "#363432",
    strokeOpacity: 0.8,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 13.5H9.5625",
    stroke: "#363432",
    strokeOpacity: 0.8,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuedProducts);
export default __webpack_public_path__ + "static/media/queued-products.cdff5042b8e49409f8fd46ab4a3c46ee.svg";
export { ForwardRef as ReactComponent };